
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import moment from 'moment';
import {
  Lead, Quotation, QuotationProperty, User,
} from '@/types';

moment.locale('it');

@Component
export default class QuotationObject extends Vue {
  @Prop(Object) readonly quotation!: Quotation;
  @Prop(Number) readonly qIndex!: number;
  @Prop({ type: Boolean, default: true }) readonly readonly!: boolean;

  get lead(): Lead {
    return this.$store.getters.currentLead;
  }

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get isSuperUser(): boolean {
    return this.user && this.user.isSuperUser;
  }

  get hasPartialData() {
    const original = JSON.parse(this.quotation.original);

    return 'quotation' in original && 'partialData' in original.quotation;
  }

  originalQuotation(quotation: Quotation, attr: QuotationProperty = null) {
    const original = quotation && 'original' in quotation && quotation.original
      ? JSON.parse(quotation.original)
      : null;

    if (!attr) {
      return original && 'quotation' in original && original.quotation
        ? original.quotation
        : null;
    }

    switch (attr) {
      case 'fabbisognoAnnuo':
        return new Intl.NumberFormat('it-IT').format(original.quotation.fabbisognoAnnuo);
      case 'potenzaDaConsumi':
        return new Intl.NumberFormat(
          'it-IT',
          { maximumFractionDigits: 2, minimumFractionDigits: 2 },
        ).format(original.quotation.partialData.potenzaDaConsumi);
      case 'potenzaDaSpazioPerformance':
        return new Intl.NumberFormat(
          'it-IT',
          { maximumFractionDigits: 2, minimumFractionDigits: 2 },
        ).format(original.quotation.partialData.potenzaDaSpazio.performance);
      case 'potenzaDaSpazioTop':
        return new Intl.NumberFormat(
          'it-IT',
          { maximumFractionDigits: 2, minimumFractionDigits: 2 },
        ).format(original.quotation.partialData.potenzaDaSpazio.top);
      case 'producibilitaAnnuaPerformance':
        return new Intl.NumberFormat(
          'it-IT',
          { maximumFractionDigits: 0 },
        ).format(original.quotation.partialData.producibilitaAnnua.performance);
      case 'producibilitaAnnuaTop':
        return new Intl.NumberFormat(
          'it-IT',
          { maximumFractionDigits: 0 },
        ).format(original.quotation.partialData.producibilitaAnnua.top);
      case 'faldePerformance':
        return original.quotation.partialData.numeroPannelliInstallabili
          .map((type: any) => type.performance);
      case 'faldeTop':
        return original.quotation.partialData.numeroPannelliInstallabili
          .map((type: any) => type.top);
      default:
        return null;
    }
  }

  mDateTime(date: Date) {
    return `${moment(date).format('L')} ore ${moment(date).format('LT')}`;
  }

  onEdit(quotation: Quotation) {
    window.location.href = `/lead/${this.lead.id}/quotation/${quotation.id}/recover`;
  }

  onShow(quotation: Quotation) {
    window.location.href = `/lead/${this.lead.id}/quotation/${quotation.id}/recover`;
  }
}
